import { createAsyncThunk } from "@reduxjs/toolkit";
import { Config } from "../../config";
import { axiosConfig } from "../../utils/util.fns";
import axios from "axios";
import { ActionChange, ResultAllFilterRequest } from "../../modal/result";

export const getAllResults = createAsyncThunk("results/all", async (query: string) => {
	const response = await axios.get(Config.apiSecureUrl + `/result?${query}`, axiosConfig());
	return response.data;
});

export const actionChange = createAsyncThunk("action/change", async (payload: ActionChange) => {
	const response = await axios.put(Config.apiSecureUrl + `/result/${payload.id}`, payload.payload, axiosConfig());
	return response.data;
});

export const bulkSelectionAction = createAsyncThunk("action/changes", async (payload: any) => {
	const response = await axios.put(Config.apiSecureUrl + "/result", payload, axiosConfig());
	return response.data;
});

export const getStudentResultsById = createAsyncThunk("results/student", async (id: number | null) => {
	const response = await axios.get(Config.apiSecureUrl + `/result/${id}`, axiosConfig());
	return response.data;
});

export const getIndividualLink = createAsyncThunk("get/individual/link", async (studentid: number | null) => {
	const response = await axios.get(Config.apiSecureUrl + `/exam/reschedule/${studentid}`, axiosConfig());
	return response.data;
});

export const shareLinkViaMail = createAsyncThunk("share/link/mail", async (payload: any | null) => {
	const response = await axios.post(Config.apiSecureUrl + "/exam/send", payload, axiosConfig());
	return response.data;
});
